'use client'

import { useEffect, useState,  } from 'react';
import MobileBanner from './MobileBanner'; 
import DesktopBanner from './DesktopBanner'; 

export default function Banner() {
  const [isMobile, setIsMobile] = useState(false);
  
  useEffect(() => {
    const checkSize = () => setIsMobile(window.innerWidth < 768);
    checkSize(); // Initial check
    window.addEventListener('resize', checkSize);
    return () => window.removeEventListener('resize', checkSize);
  }, []);

  return isMobile ? <MobileBanner /> : <DesktopBanner />;
}
